<template>
<div>
    <!-- <linkbutton toplabel="Add Account Note" @click="AddAccountNote()"/> -->
    <pencilplusbutton  @click="AddAccountNote()" />
    <!-- MODAL -->
      <actionmodal ref="mymodal"> 
        <template v-slot:body>
            <label class="titlelabel">Add Account Note</label>
            <textarea v-model="newNote"  rows="3" class="textarea"/>
            <div>
                <smallbutton  @click="closeModal" toplabel="Save"/>
                <smallbutton  @click="$refs.mymodal.closeModal()" toplabel="Cancel"/>
            </div>
            <div>
              <label class="responsemessage">{{responseMessage}}</label>
            </div>
        </template>
      </actionmodal>
    </div>
</template>

<script>
import datamethods from '../../datamethods.js'
import smallbutton from '../controls/button.vue'
import actionmodal from './actionmodal.vue'
import linkbutton from '../controls/linkbutton.vue'
import pencilplusbutton from '../controls/pencilplusbutton.vue'
export default {
    name:'accountnote',
    components:{
        smallbutton,
        actionmodal,
        linkbutton,
        pencilplusbutton
    },
    props:{
        accountId:{
            type:Number,
            required:true
        },
        
    },
    mixins:[datamethods],
    data(){
        return{
            newNote:'',
            responseMessage:''
        }
    },
    methods:{
        AddAccountNote(){

            this.NewNote=''
            this.$refs.mymodal.openModal()
        },
        async closeModal(){
            this.responseMessage=''
            let req = {
                accountId:this.accountId,
                note:this.newNote
            }
            var response = await this.callAPI(req,'addaccountnote')
            if(response.Successful){
                this.$refs.mymodal.closeModal()
                this.$emit('refresh')
            }else{
                this.responseMessage = response.Message
            }
        }
    }
}
</script>

<style>

</style>